module.exports = __webpack_public_path__ + "media/images/hitfun/icon.prize.virtual-2e58fe7b0109b3f03a3c01a8f199fabc.svg";